var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartPink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76583 19.0872C7.654 17.7124 5.69116 16.0994 3.91217 14.2769C2.65484 12.9563 1.69767 11.354 1.11218 9.58975C0.0682759 6.15386 1.2878 2.22565 4.72195 1.06668C5.61172 0.766414 6.5569 0.694467 7.47853 0.856842C8.40017 1.01922 9.27146 1.41117 10.0195 1.99998C10.7664 1.41281 11.636 1.02176 12.5558 0.859409C13.4755 0.697061 14.4189 0.768146 15.3073 1.06668C18.7414 2.22565 19.9707 6.19488 18.9268 9.58975C18.346 11.3563 17.3882 12.9597 16.1268 14.2769C14.3478 16.0994 12.385 17.7124 10.2732 19.0872L10.0487 19.2308L9.76583 19.0872Z",
    fill: "#FF5170",
    stroke: "#FF5170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPink);
export default __webpack_public_path__ + "static/media/heart-pink.8d9a692ad72b64fa212b36e43817e149.svg";
export { ForwardRef as ReactComponent };